import script from "./ExpenseImport.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseImport.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseImport.vue?vue&type=style&index=0&id=24f043ea&lang=css"

const __exports__ = script;

export default __exports__